import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Checkbox from '../Checkbox';
import Button from '../Button';

import s from './Form.module.css';

const handleSubmit = (e, onSubmit) => {
  e.preventDefault();
  onSubmit(e);
  return false;
};

const classNameFor = type => {
  if (type === Button) {
    return s.button;
  }

  if (type === Checkbox) {
    return s.checkbox;
  }

  return undefined;
};

const FieldContainer = ({ containerClassName, child }) => {
  return (
    <div
      className={cn(s.group, classNameFor(child.type), containerClassName, {
        [s.error]: child.props && child.props.error,
      })}
    >
      {child}
    </div>
  );
};

const Form = ({ onSubmit, className, noContainers, containerClassName, layout, children, ...props }) => (
  <form
    className={cn(s.root, className, {
      [s.vertical]: layout === 'vertical',
      [s.horizontal]: layout === 'horizontal',
    })}
    onSubmit={e => handleSubmit(e, onSubmit)}
    {...props}
  >
    {React.Children.map(children, child =>
      noContainers ? child : child && <FieldContainer child={child} containerClassName={containerClassName} />,
    )}
  </form>
);

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  noContainers: PropTypes.bool,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
};

Form.defaultProps = {
  containerClassName: undefined,
  noContainers: false,
  layout: 'vertical',
};

export default React.memo(Form);
